import React from 'react';
import { NavLink } from 'react-router-dom';
import { navData } from './menuData';
import { useSelector } from 'react-redux';
import { getUser } from '@app/auth/redux/selectors';
import NavItem from './nav-item';
import AkaaniLogo from '@app/assets/svgs/akaani-logo';

export default function Menu() {
  const user = useSelector(getUser);

  return (
    <div className="w-[220px] h-screen flex-col justify-between bg-[#003232] text-[#FFFFFF] font-outfit hidden lg:flex">
      <div className="flex-1">
        <div className="border-b border-[#FFFFFF12] p-5">
          <AkaaniLogo />
        </div>
        {/* NAVLINKS */}
        <div className="flex flex-col px-3 gap-[29px] mt-5">
          {navData?.map((nav, idx) => {
            return (
              <div key={idx} className="space-y-1.5">
                <p className="text-[10px] text-[#FFFFFF40] uppercase font-semibold">
                  {nav.title}
                </p>
                <div>
                  {nav.routes.map((route) => {
                    return <NavItem route={route} />;
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* LOGOUT  */}
      <div className="border-t border-[#FFFFFF12] px-2.5 py-[25px] flex items-center justify-between">
        <div className="flex flex-1 items-center gap-2.5">
          <div className="shrink-0 size-[30px] rounded-full bg-[#5DCAA5] grid place-items-center text-xs font-semibold text-[#003232] uppercase">
            {user?.first_name?.slice(0, 1)}
            {user?.last_name?.slice(0, 1)}
          </div>
          <div>
            <p className="text-xs font-medium">
              {user?.first_name} {user?.last_name}
            </p>
            <p className="text-[11px] text-[#FFFFFF59]">{user?.email}</p>
          </div>
        </div>

        <NavLink
          to="/logout"
          className="size-[26px] bg-[#FFFFFF0F] grid place-items-center rounded-[6px] shrink-0"
        >
          {logOutIcon}
        </NavLink>
      </div>
    </div>
  );
}

const logOutIcon = (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.875 11.375H2.70833C2.42102 11.375 2.14547 11.2609 1.9423 11.0577C1.73914 10.8545 1.625 10.579 1.625 10.2917V2.70833C1.625 2.42102 1.73914 2.14547 1.9423 1.9423C2.14547 1.73914 2.42102 1.625 2.70833 1.625H4.875M8.66667 3.79167L11.375 6.5L8.66667 9.20833M11.375 6.5H4.875"
      stroke="white"
      stroke-opacity="0.35"
      stroke-width="1.35417"
      stroke-linecap="round"
    />
  </svg>
);
